<template>
    <div>
        <CRechner
            ref="rechner"
            :settings="settings"
            :tarifTyp="tarifTyp"
            :addresscheck="addresscheck"
            :strassen="strassen"
            :strasse="strasse"
            :hnr="hnr"
            :hnrzusatz="hnrzusatz"
            :stadt="stadt"
            :plz="plz"
            :verbrauch="verbrauch"
            :loading="loading"
            :addressSuggestions="addressSuggestions"
            :plzAndCity="plzAndCity"
            :showSecondLine="showSecondLine"
            @changePlz="changePlz($event)"
            @tarifeAnzeigen="tarifeAnzeigen($event)"
            @changeTarifTyp="changeTarifTyp($event)"
            @searchStrasse="searchStrasse($event)"
            @searchPlzAndCity="searchPlzAndCity($event)"
            @setStrasse="setStrasse($event)"
            @setPlzAndCity="setPlzAndCity($event)"
            @setHnr="setHnr"
            @setHnrzusatz="setHnrzusatz"
            @focusStrasse="focusStrasse($event)"
            @focusoutStrasse="focusoutStrasse($event)"
            @focusPlzAndCity="focusPlzAndCity($event)"
            @focusoutPlzAndCity="focusoutPlzAndCity($event)"
            @setValid="setValid($event)"
            @setInvalid="setInvalid($event)"
            @setVerbrauch="setVerbrauch($event)"
            v-if="this.showRechner"
        />

        <TarifListe
            v-if="(this.showTariflist || this.loading) && !this.errorstatus"
            :settings="settings"
            :tarife="tarife"
            :tarifTyp="tarifTyp"
            :loading="loading"
            :hnr="hnr"
            :strasse="strasse"
            :plz="plz"
            :verbrauch="verbrauch"
            :stadt="stadt"
            :hnrzusatz="hnrzusatz"
            :grundversorger="grundversorger"
            @changeProduktfilter="changeProduktfilter($event)"
            @checkout="checkout"
            :keineTarifeHtml="keineTarifeHtml"
        />

        <section class="section section-calculator bg-white nopadd" v-if="this.errorstatus">
            <div class="tariff-filter bg-grey">
                <div class="container">
                    <div>Systemfehler - Leider konnten Ihre Angaben nicht verarbeitet werden. Bitte wenden Sie sich an
                        den Kundenservice oder versuchen es in Kürze erneut.
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import $ from 'jQuery';
import CRechner from "./components/CRechner";
import TarifListe from "./components/TarifListe";
import {getIsCodenummerUnique} from "@/service/getIsCodenummerUnique";
import md5 from "blueimp-md5";
import {getPlzAndCity} from "@/service/getPlzAndCity";
import MatchHeight from "@tannerhodges/match-height";

const defaultSettingsEl = document.getElementById('dspreisrechner');
const defaultSettings = defaultSettingsEl ? JSON.parse(defaultSettingsEl.innerHTML) : {};
// let defaultSettings = {
//     showTariflist: false,
//     gas: false,
//     strom: true
// };

export default {
    name: 'App',
    components: {
        CRechner, TarifListe
    },
    data() {
        return {
            rid: 0,
            initRechner: true,
            settings: defaultSettings,
            showRechner: false,
            showTariflist: false,
            tarife: [],
            tarifeOrig: [],
            tarifTyp: 'strom',
            addresscheck: true,
            strassen: [],
            strasse: '',
            plzAndCity: {},
            strasseOld: '',
            plzAndCityOld: {},
            stadt: '',
            plz: '',
            hnr: '',
            hnrzusatz: '',
            tarifTypValue: {
                'strom': {
                    'codenummer': 0,
                    'verbrauch': ''
                },
                'gas': {
                    'codenummer': 0,
                    'verbrauch': ''
                }
            },
            // codenummer: 0,
            verbrauch: '',
            checksumadresse: '0',
            loading: false,
            detailsClickedobj: {},
            inBochum: false,
            nbEindeutig: false,
            addressSuggestions: [],
            // zweite Zeile soll nur angezeigt werden, wenn die Netzbetreibercodenummer nicht eindeutig ist,
            // da wir in diesem Falle weitere Informationen (Straße und Hausnummer) brauchen
            showSecondLine: false,
            typing: Date.now(),
            errorstatus: false,
            grundversorger: {},
            standorteigenschaften: {},
            keineTarifeHtml: '',
            spid: 1, // Sparten-ID 1=Strom, 2=Gas
        }
    },
    mounted() {
        let that = this;
        $(document).ajaxError(function (event, jqxhr, settings) {
            // Suche liefert kein valides JSON zurück, deshalb denkt der Preisrechner, er müsste hier einen Error zeigen,
            // hat aber eigentlich gar nichts mit dem Preisrechner zu tun, deshalb checken wir den Typenum
            if (!settings.url.includes('type=7384')) {
                that.setLoader(false);
                that.setError(true);
            }
        });

        this.cleanupStorage();

        // Einstellungen laden
        if (typeof this.settings.spid != 'undefined') this.spid = this.settings.spid;
        this.getSettings();
    },
    methods: {
        initSettings: function (settings) {
            this.settings = settings;

            this.rid = this.settings.rid;
            this.showRechner = this.settings.initRechner === false ? false : true;
            if (this.settings.initTariflist == '1') this.showTariflist = true;

            if (this.settings.gas && !this.settings.strom) this.tarifTyp = 'gas';
            if (typeof this.settings.plzvorbelegung != 'undefined') this.plz = this.settings.plzvorbelegung != '0' ? this.settings.plzvorbelegung.toString() : '';

            if (this.spid == 2) this.tarifTyp = 'gas';

            // Cookiedaten auslesen
            // Eingaben speichern
            // Sessiondaten auslesen für Ergebnisseite
            let adresse = '';
            let verbrauch = '';
            let tarifTypValue = '';
            let plzAndCity = {};

            let preisrechner = localStorage.preisrechner;
            if (!preisrechner) preisrechner = {};
            else preisrechner = JSON.parse(preisrechner);

            this.showSecondLine = preisrechner.showSecondLine;


            if (typeof preisrechner.tarifTypValue != 'undefined') {
                tarifTypValue = preisrechner.tarifTypValue;
            }
            if (typeof preisrechner[this.rid] != 'undefined') {
                if (typeof preisrechner[this.rid].tarifTypValue != 'undefined') tarifTypValue = preisrechner[this.rid].tarifTypValue;
            }

            if (this.settings.cookieplzadresse == '1') {
                if (typeof preisrechner.adresse != 'undefined') {
                    adresse = preisrechner.adresse;
                    verbrauch = tarifTypValue[this.tarifTyp].verbrauch.toString();
                }
            }

            if (this.settings.initTariflist == '1' && typeof preisrechner[this.rid] != 'undefined') {
                if (typeof preisrechner[this.rid].adresse != 'undefined') {
                    adresse = preisrechner[this.rid].adresse;
                    verbrauch = tarifTypValue[this.tarifTyp].verbrauch.toString();
                }
            }

            // Werte aus URL auslesen, wenn vorhanden (für Cross-Domain-Suche auf gutundgruen.de)
            const urlParams = new URLSearchParams(location.search);
            if (urlParams.has('verbrauch')) {
                this.verbrauch = verbrauch = decodeURIComponent(urlParams.get('verbrauch'))
            }
            if (urlParams.has('codenummer')) {
                this.codenummer = decodeURIComponent(urlParams.get('codenummer'))
            }
            if (urlParams.has('sparte')) {
                this.tarifTyp = decodeURIComponent(urlParams.get('sparte'))
                tarifTypValue = {
                    [this.tarifTyp]: {
                        verbrauch: verbrauch,
                        codenummer: this.codenummer,
                    }
                }
            }
            if (urlParams.has('plz')) {
                const plz = decodeURIComponent(urlParams.get('plz'));
                const ort = decodeURIComponent(urlParams.get('ort'));
                adresse = {
                    plz: plz,
                    strasse: decodeURIComponent(urlParams.get('strasse')),
                    hnr: decodeURIComponent(urlParams.get('hnr')),
                    hnrzusatz: decodeURIComponent(urlParams.get('hnrzusatz')),
                    plzAndCity: {
                        ort: plz + ", " + ort,
                        label: plz + ", " + ort,
                        value: plz + ", " + ort,
                        plz: plz,
                        stadt: ort,
                    }
                }
                this.stadt = ort
            }

            if (adresse == '') {
                preisrechner.adresse = {'nbEindeutig': this.nbEindeutig};
            } else {
                if (typeof adresse.plz != 'undefined') {
                    this.plz = adresse.plz;
                    this.apiPlz(this.plz);
                }
                if (typeof adresse.strasse != 'undefined') this.strasse = adresse.strasse;
                if (typeof adresse.hnr != 'undefined') this.hnr = adresse.hnr;
                if (typeof adresse.hnrzusatz != 'undefined') this.hnrzusatz = adresse.hnrzusatz;
                if (typeof adresse.ort != 'undefined') this.stadt = adresse.ort;

                this.tarifTypValue = tarifTypValue;
                plzAndCity = adresse.plzAndCity;
            }
            preisrechner.tarifTypValue = this.tarifTypValue;
            if (verbrauch != '') this.verbrauch = verbrauch;

            if (typeof plzAndCity?.ort != 'undefined') this.plzAndCity = plzAndCity;
            localStorage.preisrechner = JSON.stringify(preisrechner);

            this.inBochum = this.stadt === 'Bochum';

            if (this.settings.direktrechnen == '1' || this.settings.initTariflist == '1') {
                this.direktrechnen({
                    verbrauch: this.verbrauch,
                    plzAndCity: this.plzAndCity,
                    plz: this.plz,
                    strasse: this.strasse,
                    hnr: this.hnr,
                    hnrzusatz: this.hnrzusatz
                });
                this.settings.initTariflist = '0';
            }

            if (this.settings.plzvorbelegung != '0') this.apiPlz(this.plz);
        },
        getSettings: function () {
            $.ajax({
                url: this.settings.settingsurl,
                type: 'GET',
                dataType: 'json',
                context: this,
                success: function (resp) {
                    if (resp.status) this.initSettings(resp.data);
                }
            });
        },
        setError: function (e) {
            this.errorstatus = e;
        },
        setLoader: function (e) {
            this.loading = e;
        },
        noCacheTimestamp: function () {
            return this.rid;
            // Date.now() + Math.floor((Math.random() * 99999999) + 1)
        },
        loadTariflist: function () {
            if (this.settings.debugmodus) console.log('lade Tarife');

            if (this.settings.ergebnisunterrechner == '0') {
                this.showRechner = false;
                // this.setLoader(true);
            }
            // 06.01.2023 optisch macht es mehr Sinn den Loader immer zu zeigen
            this.setLoader(true);
            let redirecturl = '';
            this.keineTarifeHtml = '';

            if (this.settings.ergebnisseitegas != '' && this.settings.ergebnisunterrechner == '0' && this.tarifTyp == 'gas') {
                redirecturl = this.settings.redirecturlgas;
                if (!this.inBochum && this.settings.ergebnisseitegasexbo != '') redirecturl = this.settings.redirecturlgasexbo;

                this.redirect(redirecturl)
            } else if (this.settings.ergebnisseitestrom != '' && this.settings.ergebnisunterrechner == '0' && this.tarifTyp == 'strom') {
                redirecturl = this.settings.redirecturlstrom;
                if (!this.inBochum && this.settings.ergebnisseitestromexbo != '') redirecturl = this.settings.redirecturlstromexbo;

                this.redirect(redirecturl)
            } else {
                // let scrollPos = $('.section-tariffswiper').offset().top - $('header').height();
                // $('html, body').animate({scrollTop: scrollPos}, '500');

                // $.ajax({
                //     url: this.settings.standorteigenschaftenUrl,
                //     type: 'POST',
                //     dataType: 'json',
                //     data: {
                //         "tx_uopreisrechner_preisrechner[commodity]": this.tarifTyp,
                //         "tx_uopreisrechner_preisrechner[plz]": this.plz
                //     },
                //     context: this,
                //     success: function (resp) {
                //         if (this.settings.debugmodus) console.log(resp);
                //         this.standorteigenschaften = resp.data;

                        $.ajax({
                            url: this.settings.grundversorgerUrl,
                            type: 'POST',
                            dataType: 'json',
                            data: {
                                "tx_uopreisrechner_preisrechner[commodity]": this.tarifTyp,
                                "tx_uopreisrechner_preisrechner[verbrauch]": this.verbrauch,
                                "tx_uopreisrechner_preisrechner[plz]": this.plz
                            },
                            context: this,
                            success: function (resp) {
                                if (this.settings.debugmodus) console.log(resp);
                                // this.setLoader(false);
                                this.grundversorger = resp.data;
                                if (this.settings.debugmodus) console.log(this.grundversorger);

                                $.ajax({
                                    url: this.settings.tarifeUrl,
                                    type: 'POST',
                                    dataType: 'json',
                                    data: {
                                        "tx_uopreisrechner_preisrechner[commodity]": this.tarifTyp,
                                        "tx_uopreisrechner_preisrechner[limit]": this.settings.tarifelimit,
                                        "tx_uopreisrechner_preisrechner[auswahltarife]": this.settings.auswahltarife,
                                        "tx_uopreisrechner_preisrechner[codenummer]": this.tarifTypValue[this.tarifTyp].codenummer,
                                        "tx_uopreisrechner_preisrechner[verbrauch]": this.verbrauch,
                                        "tx_uopreisrechner_preisrechner[plzAndCity]": this.plzAndCity.ort
                                    },
                                    context: this,
                                    success: function (resp) {
                                        if (this.settings.debugmodus) console.log(resp);
                                        this.tarife = resp.data;
                                        this.tarifeOrig = this.tarife;

                                        this.setLoader(false);
                                        this.showTariflist = true;
                                        this.renderPopover();

                                        if (this.tarife.length == 0) {
                                            this.setKeineTarifeHtml();
                                        } else {
                                            this.applyMatchHeightToTextOptions();
                                            this.setFocusTarifliste();
                                        }
                                    },
                                    // complete: function (result, status) {
                                    //     if(status == 'success')
                                    //     {
                                    //         let resp = result.responseJSON;
                                    //         if(this.settings.debugmodus) console.log(resp);
                                    //         this.tarife = resp.data;
                                    //         this.tarifeOrig = this.tarife;
                                    //         this.setLoader(false);
                                    //         this.showTariflist = true;
                                    //         this.renderPopover();
                                    //
                                    //         if(this.tarife.length == 0) {
                                    //             this.setKeineTarifeHtml();
                                    //         }
                                    //     }
                                    // }
                                });
                            }
                        });
                //     }
                // });
            }
        },
        renderPopover: function (timeout = 1000) {
            setTimeout(function () {
                window.$('[data-toggle="popover"]').popover();
            }, timeout);
        },
        checkInput: function (e) {
            const verbrauch = e.verbrauch;
            // const plz = e.plz;


            let ret = false;

            if (this.settings.debugmodus) console.log(e);

            if (verbrauch === '') this.setInvalid('#inputVerbrauch');
            // if(plzAndCity === '' || plzAndCity.toString().length < 3) this.setInvalid('#inputPLZ');


            if (verbrauch !== '' && e.plzAndCity.ort !== '' && verbrauch != null && e.plzAndCity.ort != null) {
                ret = true;
                // if(this.addresscheck) ret = true;

                // PLZ API-Check
                // PLZ-Check fehlgeschlagen, Straße wird benötigt
                // this.addresscheck = true;
            }

            if (e.plzAndCity.ort === undefined) {
                this.setInvalid('#inputPlz', 'Dies ist ein Pflichtfeld.');
                ret = false;
            } else {
                if (!this.validatePlzAndCity(e.plzAndCity.ort)) {
                    this.setInvalid('#inputPLZ', 'Bitte das Format PLZ, Stadt benutzen');
                    ret = false;
                }
            }

            this.setValid('#inputStrasse');
            // Strasse oder Hnr nicht gesetzt
            // !this.inBochum &&
            // 17.02.2023 Strasse Prüfung für alle
            if (this.showSecondLine) {
                if ((typeof e.strasse == 'undefined' || e.strasse == '' || e.strasse == null)) {
                    ret = false;
                    this.setInvalid('#inputStrasse');
                }
            }

            this.setValid('#inputAddressHausnummer');
            // if(!this.inBochum && (typeof e.hnr == 'undefined' || e.hnr == '' || e.hnr == null)){
            // 17.02.2023 !this.inBochum && HNR Prüfung für alle
            if (this.showSecondLine) {
                if ((typeof e.hnr == 'undefined' || e.hnr == '' || e.hnr == null || !/^[1-9][0-9]{0,3}$/i.test(e.hnr))) {
                    ret = false;
                    this.setInvalid('#inputAddressHausnummer', 'Dies ist ein Pflichtfeld, maximal 4 Ziffern erlaubt.');
                }
            }

            return ret;
        },
        setValid: function (e) {
            $(e).nextAll('.invalid-feedback').hide();
        },
        setInvalid: function (e) {
            $(e).nextAll('.invalid-feedback').show();
        },
        direktrechnen: function (e) {
            if (this.settings.debugmodus) console.log('direkt rechnen');
            if (this.settings.debugmodus) console.log(e);
            if (this.settings.direktrechnen == '1' || this.settings.initTariflist == '1') this.tarifeAnzeigen(e);
        },
        tarifeAnzeigen: function (e) {
            this.verbrauch = e.verbrauch;
            this.tarifTypValue[this.tarifTyp].verbrauch = e.verbrauch;
            this.tarife = [];
            this.tarifeOrig = [];
            this.keineTarifeHtml = '';

            // this.inBochum = false;
            // if(this.stadt == 'Bochum'){
            //     this.inBochum = true;
            //     this.nbEindeutig = true;
            // }

            if (this.checkInput(e)) {
                // Eingaben speichern (nur wenn Eingaben auch valide sind)
                let preisrechner = localStorage.preisrechner;
                if (!preisrechner) preisrechner = {};
                else preisrechner = JSON.parse(preisrechner);

                let cookieadresse = {
                    'plzAndCity': this.plzAndCity,
                    'plz': this.plz,
                    'strasse': this.strasse,
                    'hnr': this.hnr,
                    'hnrzusatz': this.hnrzusatz,
                    'ort': this.stadt,
                    'inBochum': this.inBochum,
                    'nbEindeutig': this.nbEindeutig
                };

                if (typeof preisrechner[this.rid] == 'undefined') preisrechner[this.rid] = {};

                preisrechner[this.rid].adresse = cookieadresse;
                preisrechner[this.rid].tarifTypValue = this.tarifTypValue;
                preisrechner.tarifTypValue = this.tarifTypValue;
                preisrechner.showSecondLine = this.showSecondLine;

                if (this.settings.cookieplzadresse == '1') {
                    preisrechner.adresse = cookieadresse;
                }
                localStorage.preisrechner = JSON.stringify(preisrechner);

                if (this.settings.debugmodus) console.log('codenummer', this.tarifTypValue[this.tarifTyp].codenummer);
                if (this.tarifTypValue[this.tarifTyp].codenummer === 0 || typeof this.tarifTypValue[this.tarifTyp].codenummer == 'undefined') this.validateCodenummer();
                else this.loadTariflist();
            }
        },
        changeProduktfilter: function (e) {
            let filterGefunden = false;
            this.tarifeOrig.forEach(function (tarif) {
                filterGefunden = false;

                e.forEach(function (filter) {
                    tarif.tarif_produktfilter.forEach(function (tpf) {
                        if (!filterGefunden && tpf.produktfilter.uid == filter) filterGefunden = true;
                    }, this);

                }, this);

                // Filter nicht in Tarif vorhanden, Tarif muss rausgenommen werden
                if (filterGefunden || e.length == 0) {
                    // this.tarife.splice(tarif, 1);
                    tarif.invisible = false;
                } else {
                    tarif.invisible = true;
                }
            }, this);
            this.renderPopover();
        },
        changeTarifTyp: function (e) {
            this.setVerbrauch(this.verbrauch);
            this.tarifTyp = e;
            this.showTariflist = false;
            // 19.01.2023 Verbrauch soll nicht geleert werden
            // this.verbrauch = '';
            // 02.02.2023 muss aber bei TarrifTyp Wechsel entsprechend angepast werden
            this.setVerbrauch(this.tarifTypValue[e].verbrauch);
        },
        changePlz: function (e) {
            if (e.plz != this.plz) {
                this.plz = e.plz;
                this.strasse = '';
                this.hnr = '';
                this.hnrzusatz = '';
                this.strassen = [];
                this.addressSuggestions = [];
                this.tarifTypValue[this.tarifTyp].codenummer = 0;
                this.showTariflist = false;
                if (this.plz.toString().length >= 3) {
                    // PLZ laden
                    this.apiPlzAndCity(this.plz);
                    // if (this.settings.direktrechnen == '1') this.direktrechnen(e); macht keinen Sinn weil Strasse und Hnr leer sind !
                }
                this.setValid('#inputPLZ');
            }
        },
        apiPlz: function (plz) {
            if (plz == '' || plz.toString().length != 5) return false;

            $.ajax({
                url: this.settings.plzUrl,
                type: 'POST',
                dataType: 'json',
                data: {
                    "tx_uopreisrechner_preisrechner[plz]": plz
                },
                context: this,
                success: function (resp) {
                    if (this.settings.debugmodus) console.log(resp);
                    if (typeof resp.data.information != 'undefined') {
                        if (this.settings.debugmodus) console.log("Fehler PLZ Abfrage!");
                        // this.setError(true);
                    } else {
                        if (resp.data.length > 0) {
                            this.stadt = resp.data[0].ort;
                            let plzAndCity = {
                                "ort": plz + ", " + this.stadt,
                                "label": plz + ", " + this.stadt,
                                "value": plz + ", " + this.stadt,
                                "plz": plz,
                                "stadt": this.stadt
                            };
                            this.setPlzAndCity(plzAndCity);
                        }
                    }
                }
            });
        },
        // apiPlzAndCity: function(plz, verbrauch, tarifTyp){
        //     if(plz === '' || plz.toString().length < 3 || verbrauch === 0) return false;
        //     $.ajax({
        //         url: this.settings.plzAndCityUrl,
        //         type: 'POST',
        //         dataType: 'json',
        //         data: {
        //             "tx_uopreisrechner_preisrechner[plz]": plz,
        //             "tx_uopreisrechner_preisrechner[verbrauch]": verbrauch,
        //             "tx_uopreisrechner_preisrechner[commodity]": tarifTyp
        //         },
        //         context: this,
        //         success: function (resp) {
        //             if(this.settings.debugmodus) console.log(resp);
        //             if(typeof resp.data.information != 'undefined') {
        //                 this.setError(true);
        //             }
        //             else {
        //                 if(resp.data.length > 0) {
        //                     this.addressSuggestions = resp.data;
        //                 }
        //             }
        //         }
        //     });
        // },
        apiPlzAndCity: function (plz) {
            getPlzAndCity(this.settings.plzAndCityUrl, plz)
                .then(response => {
                    this.addressSuggestions = response.data;
                    this.setLoader(false);
                })
                .catch((response) => {
                    if (this.settings.debugmodus) console.log(response);
                    this.setLoader(false);
                })
        },

        apiStrasse: function (ort, plz, strasse) {
            $.ajax({
                url: this.settings.strasseUrl,
                type: 'POST',
                dataType: 'json',
                data: {
                    "tx_uopreisrechner_preisrechner[ort]": ort,
                    "tx_uopreisrechner_preisrechner[plz]": plz,
                    "tx_uopreisrechner_preisrechner[strasse]": strasse
                },
                context: this,
                success: function (resp) {
                    // var respObj = resp.data;
                    if (this.settings.debugmodus) console.log(resp);
                    if (typeof resp.data.information != 'undefined') {
                        if (this.settings.debugmodus) console.log("Fehler Abfrage ApiStrasse!");
                        // this.setError(true);
                    } else this.strassen = resp.data;
                }
            });
        },
        searchStrasse: function (search, loading) {
            if (search.length > 1 && this.stadt != '' && this.plz.toString().length == 5) {
                if (this.settings.debugmodus) console.log('searching strasse');
                if (this.settings.debugmodus) console.log(search, loading);

                this.apiStrasse(this.stadt, this.plz, search);
            }
        },
        searchPlzAndCity: function (search) {
            if (search.length >= 3) {
                this.strasse = '';
                this.hnr = '';
                this.hnrzusatz = '';
                this.strassen = [];
                this.apiPlzAndCity(search);
                // let saving = setTimeout(() => {
                //     console.log("triggered > 500ms");
                // },503);
                //
                // if (search) {
                //     if(Date.now() - this.typing < 500) clearTimeout(saving)
                //     this.typing = Date.now();
                // }


            }
        },
        setStrasse: function (e) {
            this.strasse = e;
            // this.setFocusHausnummer();
        },
        setPlzAndCity: function (e) {
            if (e === null) {
                this.plzAndCity = {};
                this.plzAndCityOld = {};
                this.stadt = '';
                this.plz = '';
                return;
            }
            if (this.tarifTypValue[this.tarifTyp].codenummer != 0 && this.stadt == e.stadt && this.plz == e.plz.toString()) return;
            this.plzAndCity = e;
            this.plzAndCityOld = e;
            this.stadt = e.stadt;
            this.plz = e.plz.toString();
            this.setLoader(true);
            this.inBochum = e.stadt === 'Bochum';

            getIsCodenummerUnique(this.settings.isCodenummerUniqueUrl, this.plzAndCity.ort, this.tarifTyp)
                .then(response => {
                    if (response.status === 'success') {
                        this.showSecondLine = !response.isCodenummerUnique;
                        this.setLoader(false);
                        if(this.showSecondLine) this.setFocusStrasse();
                        else this.setFocusCalc();

                        if (response.isCodenummerUnique) {
                            this.tarifTypValue[this.tarifTyp].codenummer = response.codenummer;
                            if (this.settings.direktrechnen == '1') this.direktrechnen({
                                verbrauch: this.verbrauch,
                                plz: this.plz,
                                plzAndCity: this.plzAndCity
                            });
                        } else this.tarifTypValue[this.tarifTyp].codenummer = 0;
                    } else {
                        if (this.settings.debugmodus) console.log(response);
                    }
                })
                .catch((response) => {
                    if (this.settings.debugmodus) console.log(response.error.message);
                    this.setLoader(false);
                })


            // let showSecondLine = false;
            // if(this.addressSuggestions && this.addressSuggestions.length) {
            //   let address = this.addressSuggestions.find(function(address) {
            //       return address.label === e;
            //   });
            //
            //   if(address) {
            //     showSecondLine = !address.codenummerEindeutig;
            //   }
            // }
            // this.showSecondLine = !e.codenummerEindeutig;
        },
        setVerbrauch: function (e) {
            this.verbrauch = e;
            this.tarifTypValue[this.tarifTyp].verbrauch = e;
            this.$refs.rechner.inputVerbrauch = e;
        },
        setHnr: function (e) {
            this.hnr = e;
            this.setValid('#inputAddressHausnummer');
        },
        setHnrzusatz: function (e) {
            this.hnrzusatz = e;
            // $('#calc-button').focus(); // entfernt da sonst die Taarifliste nicht per Tab erreichbar ist
            // this.setValid('#inputAddressHausnummerZ');
            this.direktrechnen({
                verbrauch: this.verbrauch,
                plzAndCity: this.plzAndCity,
                strasse: this.strasse,
                hnr: this.hnr,
                hnrzusatz: this.hnrzusatz
            });
        },
        focusStrasse: function () {
            this.strasseOld = this.strasse;
            this.strasse = '';
            this.setValid('#inputStrasse');
        },
        focusPlzAndCity: function () {
            this.plzAndCityOld = this.plzAndCity;
            this.plzAndCity =  {
                ort: '',
                label: '',
                value: '',
                plz: '',
                stadt: '',
            };
            // this.plzAndCity =  {};
        },
        focusoutStrasse: function () {
            if (this.strasse == '') this.strasse = this.strasseOld;
            this.setValid('#inputStrasse');
        },
        focusoutPlzAndCity: function () {
            this.plzAndCity = this.plzAndCityOld;
            this.setValid('#inputPlz');
        },
        validateAddress: function () {
            if (this.settings.debugmodus) console.log('validateAdress');
            if (this.settings.debugmodus) console.log(this.plz, this.stadt, this.strasse, this.hnr, this.hnrzusatz);
            this.setLoader(true);

            // bei Bochum keine Adressvalidierung
            if (this.inBochum) this.loadTariflist();
            else {
                $.ajax({
                    url: this.settings.validateAddressUrl,
                    type: 'POST',
                    dataType: 'json',
                    data: {
                        "tx_uopreisrechner_preisrechner[ort]": this.stadt,
                        "tx_uopreisrechner_preisrechner[plz]": this.plz,
                        "tx_uopreisrechner_preisrechner[strasse]": this.strasse,
                        "tx_uopreisrechner_preisrechner[hnr]": this.hnr + ((this.hnrzusatz != '') ? ' ' + this.hnrzusatz : '')
                    },
                    context: this,
                    success: function (resp) {
                        var respObj = resp.data;
                        if (this.settings.debugmodus) console.log(respObj);
                        this.setLoader(false);

                        if (respObj === null) {
                            if (this.settings.debugmodus) console.log("Fehler Adressabfrage!");
                            // this.setError(true);
                        } else {
                            if (typeof respObj.informationen == 'undefined') {
                                if (this.settings.debugmodus) console.log("Fehler Adressinformationen!");
                                // this.setError(true);
                            } else {
                                if (respObj.informationen.length > 0) {
                                    if (this.settings.debugmodus) console.log(respObj.informationen);
                                    if (this.settings.debugmodus) console.log("Adresse nicht gefunden!");
                                    // this.setError(true);
                                } else {
                                    this.loadTariflist();
                                }
                            }
                        }
                    }
                });
            }
        },
        validateCodenummer: function () {
            let checksumadresse = this.getChecksum([this.tarifTyp, this.stadt, this.plz, this.strasse, this.hnr, this.hnrzusatz, this.plzAndCity]);
            if (this.settings.debugmodus) console.log(checksumadresse);
            this.setLoader(true);

            // if(checksumadresse == this.checksumadresse) this.loadTariflist();
            // else {
            this.checksumadresse = checksumadresse;

            $.ajax({
                url: this.settings.codenummerurl,
                type: 'POST',
                dataType: 'json',
                data: {
                    "tx_uopreisrechner_preisrechner[commodity]": this.tarifTyp,
                    "tx_uopreisrechner_preisrechner[ort]": this.stadt,
                    "tx_uopreisrechner_preisrechner[plzAndCity]": this.plzAndCity.ort,
                    "tx_uopreisrechner_preisrechner[strasse]": this.strasse,
                    "tx_uopreisrechner_preisrechner[hnr]": this.hnr + ((this.hnrzusatz != '') ? ' ' + this.hnrzusatz : '')
                },
                context: this,
                success: function (resp) {
                    var respObj = resp;
                    if (this.settings.debugmodus) console.log(respObj);
                    this.setLoader(false);

                    if (respObj.data == '0') {
                        if (this.settings.debugmodus) console.log(respObj);
                        if (this.settings.debugmodus) console.log("Codenummer Fehler Lieferant kann für diese Adresse nicht ermittelt werden!");
                        // this.setError(true);
                    } else {
                        this.tarifTypValue[this.tarifTyp].codenummer = respObj.data;
                        this.nbEindeutig = respObj.nbEindeutig;

                        let preisrechner = localStorage.preisrechner;
                        if (!preisrechner) preisrechner = {};
                        else preisrechner = JSON.parse(preisrechner);

                        preisrechner.adresse.nbEindeutig = this.nbEindeutig;
                        preisrechner[this.rid].adresse.nbEindeutig = this.nbEindeutig;
                        preisrechner.tarifTypValue[this.tarifTyp].codenummer = this.tarifTypValue[this.tarifTyp].codenummer;
                        preisrechner[this.rid].tarifTypValue[this.tarifTyp].codenummer = this.tarifTypValue[this.tarifTyp].codenummer;
                        preisrechner.showSecondLine = this.showSecondLine;

                        localStorage.preisrechner = JSON.stringify(preisrechner);

                        this.validateAddress();
                    }
                }
            });
            // }
        },
        getChecksum: function (data) {
            return md5(data);
        },
        checkout: function (tarif, preisoptionen, jvl) {
            let preisrechner = localStorage.preisrechner;
            preisrechner = JSON.parse(preisrechner);

            // Codenummer ergänzen damit es für den Checkout passt
            preisrechner[this.rid].adresse.codenummer = this.tarifTypValue[this.tarifTyp].codenummer;

            let preisrechnerData = {
                'rid': this.rid,
                'verbrauch': this.verbrauch,
                'tarif': {
                    'id': tarif.uid,
                    'typ': this.tarifTyp,
                    'preis': tarif.preis,
                    'preis_id': tarif.preis_id,
                    'preisoptionen': preisoptionen
                },
                'adresse': preisrechner[this.rid].adresse,
                'tarifTypValue': this.tarifTypValue,
                'jvl': jvl,
                'grundversorger': this.grundversorger,
                'standorteigenschaften': this.standorteigenschaften,
                'showSecondLine': this.showSecondLine
            }

            preisrechner[this.rid] = preisrechnerData;
            localStorage.preisrechner = JSON.stringify(preisrechner);

            $.ajax({
                url: this.settings.checkoutapiurl,
                type: 'POST',
                dataType: 'json',
                data: {
                    "tx_uopreisrechner_preisrechner[data]": JSON.stringify(preisrechner)
                },
                context: this,
                success: function (resp) {
                    if (resp.status) window.location.href = ((!this.inBochum && this.settings.checkouturlexbo != '') ? this.settings.checkouturlexbo : this.settings.checkouturl);
                }
            });
        },
        cleanupStorage: function () {
            let preisrechner = localStorage.preisrechner;
            if (preisrechner) {
                preisrechner = JSON.parse(preisrechner);
                Object.keys(preisrechner).forEach(key => {
                    // max 1 Tag alt 86400
                    // 10 Minuten 600
                    if (!isNaN(key) && key < Math.floor(Date.now() / 1000) - 86400) delete preisrechner[key];
                });
                if (!Object.keys(preisrechner).length) preisrechner = {};
                localStorage.preisrechner = JSON.stringify(preisrechner);
            }
        },
        validatePlzAndCity: function (value) {
            const plzAndCityRegex = new RegExp("^\\d{5}, [.-a-z äöüß]+$", "i");
            return plzAndCityRegex.test(value);
        },
        setKeineTarifeHtml() {
            let keineTarifeHtml = (typeof this.settings.keineTarifeHtml == 'string') ? this.settings.keineTarifeHtml : '';
            let gutUndGruenLink = (typeof this.settings.gutUndGruenLink == 'string') ? this.settings.gutUndGruenLink : '';
            gutUndGruenLink = gutUndGruenLink.replace('{commodity}', this.tarifTyp).replace('{plz}', this.plz).replace('{verbrauch}', this.verbrauch).replace('{stadt}', encodeURIComponent(this.stadt)).replace('{strasse}', encodeURIComponent(this.strasse)).replace('{hausnummer}', this.hnr).replace('{hausnummerzusatz}', this.hnrzusatz);
            keineTarifeHtml = keineTarifeHtml.replace('{{GutUndGruenLink}}', gutUndGruenLink);
            this.keineTarifeHtml = keineTarifeHtml;
        },
        redirect(redirectUrl) {
            if (redirectUrl.startsWith('/')) {
                redirectUrl = location.origin + redirectUrl
            }

            const url = new URL(redirectUrl)

            if (url.host !== location.host || location.host === '127.0.0.1:3140') {
                url.searchParams.append('sparte', encodeURIComponent(this.tarifTyp))
                url.searchParams.append('plz', encodeURIComponent(this.plz))
                url.searchParams.append('ort', encodeURIComponent(this.stadt))
                url.searchParams.append('strasse', encodeURIComponent(this.strasse))
                url.searchParams.append('hnr', encodeURIComponent(this.hnr))
                url.searchParams.append('hnrzusatz', encodeURIComponent(this.hnrzusatz))
                url.searchParams.append('verbrauch', encodeURIComponent(this.verbrauch))
                url.searchParams.append('codenummer', encodeURIComponent(this.tarifTypValue[this.tarifTyp].codenummer))
            }

            window.location.href = url.toString();
        },
        applyMatchHeightToTextOptions() {
            this.$nextTick(() => {
                const elements = this.$el.querySelectorAll('.txt-02 .options-intro');
                MatchHeight.add(elements, 'text-options');
            });
        },
        setFocusStrasse(){
            this.$nextTick(() => {
                this.$el.querySelector('#vstrasse' + this.settings.rid).focus();
            });
        },
        setFocusHausnummer(){
            this.$nextTick(() => {
                this.$el.querySelector('#inputAddressHausnummer').focus();
            });
        },
        setFocusTarifliste(){
            // this.$nextTick(() => {
            //     this.$el.querySelector('#tarifliste button:first-child').focus();
            // });
        },
        setFocusCalc(){
            this.$nextTick(() => {
                this.$el.querySelector('#calc-button').focus();
            });
        },
    }
}
</script>

